import { postMultiPart } from "../../shared/data";

export const uploadContent = (data) => {
    const formData = new FormData();
    formData.append("file", data.files[0]);
    formData.append("workflowType", data.workflowType);

    return postMultiPart(`/file-uploads`, formData, { passthrough: true, noRedirect: true });
};
